import { MapNotes }     from './mapnotes'
import { MockMapNotes } from './mock-mapnotes'

const MapNotesLoader = (isMock, include = true) => {
    if (!include) return {}

    return isMock ? MockMapNotes : MapNotes
}

export { MapNotesLoader }
